import Modal from "../Modal";
import ClaimNewForm from "../../forms/claim/ClaimNewForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function ClaimNewModal({ show, handleClose, opportunity }) {
  const { t } = useTranslation();
  return (
    <Modal
      title={t("claims.newClaim")}
      show={show}
      handleClose={handleClose}
      width="800px"
    >
      <ClaimNewForm handleClose={handleClose} opportunity={opportunity} />
    </Modal>
  );
}
